import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import UserAvatar from './UserAvatar';
import { store } from '../../store/store';
import AclContextProvider from '../../Modules/Acl/Components/AclContextProvider';
import { Provider } from 'react-redux';

loadDOMComponent({
	selector: 'react-user-avatar',
	callback: ({ container }: any) => {
		const userId = container.getAttribute('userId');
		const dataClass = container.getAttribute('data-class') || null;
		let dataType = container.getAttribute('data-type') || 'img';
		if (dataType !== 'img' && dataType !== 'background') {
			dataType = 'img';
		}

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<UserAvatar
							userId={userId}
							customClass={dataClass}
							type={dataType}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
